import angular from 'angular';

import ComponentModule from './component';
import CategoryEditModalComponent from './category-edit-modal.cmpt';

export default angular
    .module('application.component.modals.component.category-edit-modal', [
        ComponentModule.name
    ])
    .component(CategoryEditModalComponent.selector, CategoryEditModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/index.js